import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DeliverydayService } from 'src/_service/DeliverydayService';
import { LocalizedDatePipe } from '../pipe/localizedDate.pipe';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { WeekFromTo } from 'src/_model/postalcodedelivery';
import { OrderService } from 'src/_service/OrderService';
import { CheckdialogData, Countrycode, Dialogtype } from 'src/_model/shared';
import { environment } from 'src/_environments/environment';
import { Flowtype, Shippingmethod } from 'src/_model/order';
import { GlobalService } from 'src/_service/GlobalService';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CheckdialogComponent } from '../checkdialog/checkdialog.component';

@Component({
  selector: 'app-first-delivery-recipeweek-selector',

  templateUrl: './first-delivery-recipeweek-selector.component.html',
  styleUrl: './first-delivery-recipeweek-selector.component.scss',
  imports: [LocalizedDatePipe, TranslateModule],
})
export class FirstDeliveryRecipeweekSelectorComponent {

  @Input({required:true}) flowtype: Flowtype
  @Output() weekChange: EventEmitter<WeekFromTo> = new EventEmitter();
  @Input({required:true}) canChangeWeek: any = ()=> new Promise<boolean>(resolve => resolve(true))

  availableFirstDeliveryRecipeweeks: BehaviorSubject<WeekFromTo[]>;

  selectedIndex = 0;

  constructor(
    private _deliverydayService: DeliverydayService,
    private _orderService: OrderService,
    private _globalService: GlobalService,
    //these 'unused' services are needed for the checkremove recipes popup in the cms-week-favorites component
    private _modalService: NgbModal,
    private _translate: TranslateService
  ) {
  }

  get selectedWeek() {
    return this.availableFirstDeliveryRecipeweeks.value[this.selectedIndex]
  }
  get canGoBack() {
    return this.availableFirstDeliveryRecipeweeks.value[this.selectedIndex - 1]
  }
  get canGoForward() {
    return this.availableFirstDeliveryRecipeweeks.value[this.selectedIndex + 1]
  }

  ngOnInit() {

    this.availableFirstDeliveryRecipeweeks = this._deliverydayService.availableFirstDeliveryRecipeweeks$;

    if (this.availableFirstDeliveryRecipeweeks.value.length === 0) {
      this.getAvailableDeliveryDatesAndSetFirstWeek()
    } else {
      this.setWeekIndexFromDeliverydate();
    }

    this.changeWeek(0)

  }

  async changeWeek(i: number) {

    if (i !== 0) {
      if(await this.canChangeWeek() === false)
        return;
    }

    const changeTo = this.selectedIndex + i
    if (!this.availableFirstDeliveryRecipeweeks.value[changeTo]) return;

    this.selectedIndex = changeTo;
    this.weekChange.emit(this.selectedWeek)
    this.setAvailableDeliverydate();
  }

  private setAvailableDeliverydate() {
    const deliverydate = this._orderService.orderFlowForm.get('deliverydate').value?.toString();

    //shouldnt update available date
    if (!this.selectedWeek.deliverydays.map(m => m.date.toString()).includes(deliverydate))
      this._orderService.orderFlowForm.get('deliverydate').setValue(this.selectedWeek.deliverydays.at(0).date)

  }

  private getAvailableDeliveryDatesAndSetFirstWeek() {

    const countrycodeValue = this._orderService.orderFlowForm.get('shippingaddresscountrycode')?.value as Countrycode || this._globalService.getPricecountry() as string;
    const countrycode = countrycodeValue as Countrycode || Countrycode.NL;

    const postalcode = environment.assumedPostalcode[countrycode];
    const shippingmethod = this._orderService.orderFlowForm.get('shippingmethod')?.value as Shippingmethod || Shippingmethod.DOOR_DELIVERY;

    const numberpattern = /\d+/g;
    const postalcodenumbers = postalcode?.match(numberpattern)?.[0];

    this._deliverydayService.getFirstdelivery(shippingmethod, postalcodenumbers, countrycode).subscribe(
      () => {
        this.setWeekIndexFromDeliverydate();
        this.changeWeek(0)
      }

    )
  }

  /**
   * 
   * Sets correct weekindex from selected deliverydate
   */
  private setWeekIndexFromDeliverydate() {
    const deliverydate = this._orderService.orderFlowForm.get('deliverydate').value?.toString();
    if(!deliverydate) return;

    const deliveryday = this.availableFirstDeliveryRecipeweeks.value.flatMap(m => m.deliverydays).find(d => d.date === deliverydate);
    if (!deliveryday) return;

    this.selectedIndex = this.availableFirstDeliveryRecipeweeks.value.findIndex(f => f.deliverydays.includes(deliveryday));
  }

}
